export default __webpack_public_path__ + "static/media/image-preview-video.8fd9290c.jpg";